<template>
    <b-modal :active.sync="show" id="createContractModal" aria-modal :width="600" :can-cancel="false">
        <div class="modal-card" style="width: auto">
            <header class="modal-card-head" v-show="status == ''"><p class="modal-card-title">Contract aanmaken</p></header>
            <section class="modal-card-body" style="overflow: hidden;">

                <div v-if="status == ''">
                    <p><strong>PDF bestanden</strong></p>
                    <div class="field">
                        <b-checkbox v-model="createSteps.create_agreement">Genereer het huurovereenkomst PDF-bestand.</b-checkbox>
                    </div>
                    <div class="field">
                        <b-checkbox v-model="createSteps.create_general">Genereer het algemene bepaling PDF-bestand.</b-checkbox>
                    </div>

                    <p><strong>E-mail</strong></p>
                    <div class="field">
                        <b-checkbox v-model="createSteps.send_mail">Verstuur een e-mail ter bevestiging naar {{ customerEmail }}.</b-checkbox>
                    </div>
                    <div class="field">
                        <b-checkbox v-model="createSteps.mail_attachments" :disabled="!createSteps.send_mail || (!createSteps.create_agreement && !createSteps.create_general) || user.role != 'pit'">Verstuur de gegenereerde PDF-bestanden mee per mail.</b-checkbox>
                    </div>

                    <div v-show="user.role == 'pit' || user.organisation_connect">
                        <p><strong>Toegang</strong></p>
                        <div class="field">
                            <b-checkbox v-model="createSteps.connect">Toegang aanmaken na maken van contract.</b-checkbox>
                        </div>
                    </div>
                </div>
                <div v-else>
                    <div class="process-image">
                        <img src="/images/undraw_agreement_aajr.svg" alt="process image" v-show="status == 'creating_contract'">
                        <img src="/images/undraw_printing_invoices_5r4r.svg" alt="process image" v-show="status == 'creating_invoices'">
                        <img src="/images/undraw_subscribe_vspl.svg" alt="process image" v-show="status == 'finalizing'">
                        <img src="/images/undraw_project_completed_w0oq.svg" alt="process image" v-show="status == 'created'">
                    </div>

                    <h3 class="text-center">
                        <span v-if="status == 'creating_contract'">Contract aanmaken..</span>
                        <span v-if="status == 'creating_invoices'">Factuur klaarzetten..</span>
                        <span v-if="status == 'finalizing'"><span v-show="createSteps.create_agreement || createSteps.create_general">Contract genereren</span><span v-show="createSteps.send_mail">&nbsp;en mail klaarzetten</span>..</span>
                        <span v-if="status == 'created'">Gereed!</span>
                    </h3>

                    <b-progress :value="stepsPercentage"></b-progress>
                </div>
            </section>
            <footer class="modal-card-foot text-right" v-show="status == ''">
                <button class="button" type="button" @click="$emit('cancelCreatingContract')">Annuleren</button>
                <button class="button is-success" @click="$emit('create', createSteps)">Aanmaken</button>
            </footer>
        </div>
    </b-modal>
</template>

<script>
export default {
    name: 'ContractsRecordCreateModal',

    props: {
        show: {
            type: Boolean,
            required: true,
            default: false
        },
        status: {
            type: String,
            required: true,
            default: ''
        },
        customerEmail: {
            type: String,
            required: false
        }
    },

    data() {
        return {
            createSteps: {
                create_agreement: true,
                create_general: true,
                send_mail: true,
                mail_attachments: true,
                connect: false
            }
        }
    },

    computed: {
        stepsPercentage() {
            switch(this.status) {
                case 'creating_contract':
                    return 0
                break;
                case 'creating_invoices':
                    return 33
                break;
                case 'finalizing':
                    return 66
                break;
                case 'created':
                    return 100
                break;
                default:
                    return 0
                break;
            }
        },

        user() {
            return this.$store.state.user
        }
    },

    created() {
        if (this.user.role == 'pit' || this.user.organisation_connect) {
            this.createSteps.connect = true
        }
    },

    watch: {
        'createSteps.create_agreement': function(newVal) {
            if(!newVal && !this.createSteps.create_general){
                this.createSteps.mail_attachments = false
            }
        },

        'createSteps.create_general': function(newVal) {
            if(!newVal && !this.createSteps.create_agreement){
                this.createSteps.mail_attachments = false
            }
        },

        'createSteps.send_mail': function(newVal) {
            if(!newVal){
                this.createSteps.mail_attachments = false
            }
        }
    }
}
</script>